<div
  class="text-danger input-error"
  [wlAutomationId]="automationId"
  [wlTrackError]="{
    rendering: rendering,
    field: stripSymbols(field ?? label | lowercase),
    description: stripSymbols(description | lowercase),
    type: errorType,
    stepName: stepName,
    step: step,
    toolName: toolName,
  }"
>
  @if (messageField) {
    <wl-rich-text-wrapper [field]="{ value: field }" [rendering]="rendering">
      <small></small>
    </wl-rich-text-wrapper>
  }
  @if (label) {
    <small>{{ label }}</small>
  }
</div>
